import { createFileRoute } from '@tanstack/react-router'
import SitePage from '@/pages/sites/site-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota index para /dashboard/$dashboardId/sites/$siteId
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/',
)({
  component: function SiteRoute() {
    const { dashboardId, siteId } = Route.useParams()
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_SITES_BLOG}>
        <SitePage dashboardId={dashboardId} siteId={siteId} />
      </ProtectedRoute>
    )
  },
})
